
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Haben Sie ein Lieblingsrezept?</b><br />
Die Fischfrikadellen mit Sauerkraut und die Lachsnudeln mag ich gerne. Aber auch viele Linsengerichte wie die Linsensuppe meiner Schwester, die ich gestern erst gemacht habe.
    <b>Ernährung für Erwachsene ist das Eine. Sie sind auch Vater. Hand aufs Herz: Mögen die Kinder Ihre gesunde Kost?</b><br />
Ach, das ist so schwierig (seufzt). Ich will ja meinen Kindern keine Essstörung anerziehen, deshalb halte ich mich da stark zurück. Aber klar, ich achte automatisch darauf, das passiert natürlich schon beim Einkaufen. Am meisten versuche ich, den Zucker zu reglementieren. Also, es gibt bei uns keine Cola oder so. Süssigkeiten nur manchmal. Und beim Abendessen bieten wir oft eine Auswahl an verschiedenen Gerichten an, die alle halbwegs gesund sind, wie zum Beispiel Nudeln mit Tomatensauce oder zur Not auch nur ein Joghurt mit Banane, falls sie nicht so viel Hunger haben.
    <b>Gibt es überhaupt eine generelle gesunde Ernährung? Denn was für den einen Menschen bekömmlich ist, ist für den anderen unverträglich.</b><br />
Klar gibt es die. Cola und Pommes und Wurst ist für niemanden gesund. Umgekehrt gibt es keinen Menschen, dem Gemüse schaden würde. Insofern gibt es selbstverständlich universelle Prinzipien. Man soll so viel wie möglich Vollkornprodukte, Gemüse, Hülsenfrüchte und Obst zu sich nehmen. So einfach ist das. Der Rest ist Beiwerk.
    <b>Die richtige Ernährung scheint bei vielen zu einem Religionsersatz geworden zu sein.</b><br />
Ja, das ist schon langsam zu einem Klischee geworden. Es stimmt schon, dass manche Leute es übertreiben, dann hat es was von einer Sekte oder Religion. Mich interessiert das nicht. Mir ging es darum, mich selbst zu heilen. Wenn es um dein Leben geht, interessierst du dich für das, was wirkt. Nicht mehr und nicht weniger. Ich weiss auch, dass man nicht so superstreng sein muss, um gesund zu leben. Lieber weniger streng und damit langfristig gut leben können.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;